export const CURRENCY = "$";
export const recordsLimit = 10;
export const notProtectedRoutes = ["", "account-settings", "notifications"];
export const UserPermissionRoutes = {
  "user-management": "user-management",
  staff: "staff-management",
  roles: "role-management",
  bot: "bot-management",
  "view-chat": "view-chat",
  "system-settings": "system-settings",
  "purchase-commission": "purchase-commission",
  "reporting-analytics": "analytics",
  "subscription-management": "subscription-management",
  "product-details": "user-management",
  "integration-management": "integration-management",
};
export const subPermissionRoutes = {
  view: "view",
  edit: "update",
  add: "create",
};
export function getPathnameByUrl(url) {
  const cleanedUrl = url?.startsWith("/") ? url?.slice(1) : url;
  const segments = cleanedUrl?.split("/");
  return [segments?.[0], segments?.[1]];
}
export const PRODUCT_STATUS = {
  IN_STOCK: "in-stock",
  OUT_OF_STOCK: "out-of-stock",
};
export const KEY_STATUS = {
  PENDING: "pending",
  IN_PROGRESS: "in-progress",
  ACTIVE: "active",
  SUSPENDED: "suspended",
};
export const RELEASE_STATUS = {
  PENDING: "pending",
  RELEASED: "released",
  REJECTED: "rejected",
};
